// GA4 (gtag.js) integration for the SPA.
//
// IMPORTANT: gtag.js consumes `window.dataLayer` entries as Arguments objects
// (the canonical install uses `function gtag(){dataLayer.push(arguments);}`).
// If we push plain Arrays instead — e.g. via `(...args) => dataLayer.push(args)` —
// gtag.js will silently drop every event and never POST to /g/collect, which
// produces the "No data received from your website yet" screen in GA4.
// Always keep the `arguments`-based push below to preserve that contract.

const GA_SCRIPT_SELECTOR = 'script[data-aviatto-ga4="true"]';

export function getGoogleAnalyticsMeasurementId() {
  return String(import.meta.env.VITE_GA_MEASUREMENT_ID || '').trim();
}

export function initGoogleAnalytics() {
  const measurementId = getGoogleAnalyticsMeasurementId();
  if (!measurementId || typeof window === 'undefined' || typeof document === 'undefined') {
    return false;
  }

  if (window.gtag || document.head.querySelector(GA_SCRIPT_SELECTOR)) {
    return false;
  }

  const script = document.createElement('script');
  script.async = true;
  script.dataset.aviattoGa4 = 'true';
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  // Canonical gtag stub — pushes the raw `arguments` object so gtag.js can
  // dispatch each call. Do NOT replace with an arrow function that pushes a
  // rest-spread Array (see header comment).
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', measurementId, { send_page_view: false });
  return true;
}

export function trackPageView(path) {
  const measurementId = getGoogleAnalyticsMeasurementId();
  if (!measurementId || typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return false;
  }

  const pagePath = path || `${window.location.pathname}${window.location.search}${window.location.hash}`;
  const pageLocation = new URL(pagePath, window.location.origin).href;

  window.gtag('event', 'page_view', {
    page_path: pagePath,
    page_location: pageLocation,
    page_title: document.title,
  });
  return true;
}
